// extracted by mini-css-extract-plugin
export default {"layout":"\"../../styles/variables/layout.module.css\"","gap-m":"16px","form":"Form_form__l0zsp"};